/* Careatic product row slider — arrows scroll one card at a time; arrows disable
   at the ends and hide entirely when there's no overflow. Native swipe handles
   touch. Event-delegation-free; re-inits on Shopify section load. */
(function () {
  'use strict';

  function init(prow) {
    var track = prow.querySelector('[data-ca-prow-track]');
    var prev = prow.querySelector('[data-ca-prow-prev]');
    var next = prow.querySelector('[data-ca-prow-next]');
    if (!track) return;

    function step() {
      var first = track.children[0];
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
      return Math.round(first.getBoundingClientRect().width + gap);
    }

    function update() {
      var EPS = 6;
      var max = track.scrollWidth - track.clientWidth;
      var overflow = max > 2;
      prow.classList.toggle('ca-prow--static', !overflow);
      if (prev) prev.disabled = track.scrollLeft <= EPS;
      if (next) next.disabled = track.scrollLeft >= max - EPS;
    }

    try { track.scrollLeft = 0; } catch (e) {}   // start at the first card (ignore scroll restoration)

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    update();
    // re-check once images/fonts settle and widths are final
    window.addEventListener('load', update);
    setTimeout(update, 300);
  }

  function boot() { document.querySelectorAll('[data-ca-prow]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var p = e.target.querySelector && e.target.querySelector('[data-ca-prow]');
    if (p) init(p);
  });
})();
